window.addEventListener('load', () => {
  const ventesItem = document.querySelectorAll('.offre-item');
  const modal = document.querySelector('#modal');

  ventesItem.forEach((item) => {
    item.addEventListener('click', () => {
      modal.querySelector('.title').textContent =
        item.getAttribute('data-title');

      modal.querySelector('.content-style').innerHTML = item?.querySelector(
        '.description-detaillee'
      ).innerHTML;

      modal.setAttribute('data-visible', 'true');
    });
  });

  document.querySelector('.modal__close').addEventListener('click', () => {
    modal.setAttribute('data-visible', '');
  });
});
